/**
 * Created by haikuan.gu@qunar.com
 * Date: 2020/5/26
 * Time: 10:27 上午
 * 提示信息处理工具
 */
var errorHandler = {
  _pre: '[QReact-Ext Router] ',
  warn: function warn(str) {
    console.warn(this._pre + str);
  },
  noView: function noView(name) {
    this.warn("\u9875\u9762 ".concat(name, " \u672A\u6CE8\u518C"));
  },
  noRoute: function noRoute(name) {
    this.warn("\u9875\u9762 ".concat(name, " \u4E0D\u5728\u8DEF\u7531\u5386\u53F2\u4E2D"));
  },
  noIndexView: function noIndexView() {
    this.warn('native 未设置 view');
  },
  noAppName: function noAppName() {
    this.warn('请设置 React.Ext.defaults.appName 配置应用名');
  },
  noNavBarElem: function noNavBarElem() {
    this.warn('导航栏还未准备好');
  }
};
export default errorHandler;